import { render } from "./DocumentBrowser.vue?vue&type=template&id=760df6da&ts=true"
import script from "./DocumentBrowser.vue?vue&type=script&lang=ts"
export * from "./DocumentBrowser.vue?vue&type=script&lang=ts"

import "./DocumentBrowser.vue?vue&type=style&index=0&id=760df6da&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__